import { KlevuTypeOfRecord, KlevuTypeOfRequest, } from "../../models/index.js";
const defaults = {
    id: "categoryMerchandising",
    searchTerm: "*",
    typeOfRecords: [KlevuTypeOfRecord.Product],
    limit: 24,
};
/**
 * Fetch products for a category listing page.
 * Default result id is "categoryMerchandising".
 *
 * @category Query
 * @param category
 * @param options
 * @returns
 */
export function categoryMerchandising(category, options, ...modifiers) {
    const params = Object.assign(Object.assign({}, defaults), options);
    const query = {
        id: params.id,
        typeOfRequest: KlevuTypeOfRequest.CategoryNavigation,
        settings: Object.assign({ query: {
                categoryPath: category,
                term: params.searchTerm,
            } }, params),
    };
    return {
        klevuFunctionId: "categoryMerchandising",
        queries: [query],
        modifiers,
        params: Object.assign(Object.assign({}, params), { category }),
    };
}
